import Vue from 'vue'
import 'vue-loaders/dist/vue-loaders.css'
import VueLoaders from 'vue-loaders'

Vue.use(VueLoaders)
